import React from 'react';
import { compose, withState, withHandlers, withProps, lifecycle } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import withLoader from '../app/withLoader';
import { withRouter } from 'react-router-dom';
import AddProductForm from './form/addForm';
import { createProduct } from './_api';
import { getCategory } from '../categories/_api';
import { get } from 'lodash';
import { attributeValueGet } from '../app/_api';
import { addAttributeProductValue } from './_api';
import { withSnackbar } from 'notistack';

const styles = theme => ({
  root: {
    width: '100%',
    margin: 20,
  },
  paper: {
    padding: theme.spacing.unit,
    textAlign: 'left',
    color: theme.palette.text.secondary,
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
});

const enhance = compose(
  withStyles(styles),
  withSnackbar,
  withLoader,
  withRouter,
  withState('category', 'setCategory', null),
  withState('product', 'setProduct', null),
  withProps(({ match: { params: { id } } }) => {
    return { categoryId: id };
  }),
  lifecycle({
    async componentDidMount() {
      const { categoryId, setCategory, toggleLoader } = this.props;
      toggleLoader();
      const resp2 = await getCategory(categoryId);
      if (resp2) {
        Promise.all(
          get(resp2, 'attributes', []).map(async item => {
            const values = await attributeValueGet(item.id);
            return { ...item, values: values.items };
          }),
        ).then(values => {
          setCategory(values);
        });
      }
      toggleLoader(false);
    },
  }),
  withHandlers({
    onSubmit: ({
      history,
      categoryId,
      setProduct,
      setCategory,
      enqueueSnackbar,
    }) => async values => {
      const resp = await createProduct(categoryId, {
        name: get(values, 'name', ''),
        description: get(values, 'description', ''),
      });
      if (get(resp, 'success', false)) {
        const product = resp.data;
        setProduct(product);
        const resp2 = await addAttributeProductValue(product.id, values.attributes);
        if (get(resp2, 'success', false)) {
          enqueueSnackbar('Produkt byl úspěšně vytvořen.', { variant: 'success' });
          history.push('/products');
        } else {
          enqueueSnackbar('Produkt se nepodařilo vytvořit.', { variant: 'error' });
        }
      }
    },
  }),
);

export default enhance(
  ({ classes, onSubmit, onSubmitAttrs, handleExpansionChange, expanded, product, category }) => (
    <div className={classes.root}>
      <h3>Přidat produkt</h3>
      <Paper className={classes.paper}>
        <AddProductForm add={true} onSubmit={onSubmit} category={category} />
      </Paper>
    </div>
  ),
);



// WEBPACK FOOTER //
// ./src/modules/products/add.js